import { get, post, put } from 'api';
import config from 'config';
import { CustomerTagTitle } from '../models/customer-tag-title';
import { AutoSyncSettingRequest, AutoSyncSettings } from '../models/auto-sync-settings';

const dealerUrl = config.get('api.dealer');
const CustomerSettingsApi = {
   async getCustomerTags(maxCountLimit: number = 5000): Promise<CustomerTagTitle[]>{
     const url = `${dealerUrl}/dealers/getCustomerTagTitles/${maxCountLimit}`;
     const {data} = await get(url)
     return data;
   },
   async updateCustomerTags(payload: CustomerTagTitle): Promise<boolean>{
    const url = `${dealerUrl}/dealers/updateCustomerTags`;
    const { data } = await put(url, payload);
    return data;
  },
  async insertCustomerTagSetting(payload: CustomerTagTitle): Promise<boolean> {
    const url = `${dealerUrl}/dealers/insertCustomerTagSetting`;
    const { data } = await post(url, payload);
    return data;
  },
  async getCustomersAutoSyncSettings(): Promise<AutoSyncSettings[]> {
    const url = `${dealerUrl}/dealers/customersAutoSyncSettings`;
    const { data } = await get(url);
    return data;
  },
  async setCustomersAutoSyncSetting(payload: AutoSyncSettingRequest): Promise<AutoSyncSettings[]> {
    const url = `${dealerUrl}/dealers/setCustomersAutoSyncSetting`;
    const { data } = await post(url, payload);
    return data;
  },
};

export default CustomerSettingsApi;
